import { __assign } from "tslib";
import { RandomGenerator } from '../../../test-utils';
import { ReplyType } from '../enums/reply-type.enum';
import { TimelineItemType, } from './timeline';
import { ExtendedTicketBuilder } from './../extended-ticket.builder';
var TimelineBuilder = /** @class */ (function () {
    function TimelineBuilder() {
        var _this = this;
        this.addTimelineItem = function (timelineItem) {
            _this.timeline.timelineItems.push(timelineItem);
            return _this;
        };
        this.timeline = {
            ticket: new ExtendedTicketBuilder().build(),
            timelineItems: []
        };
    }
    TimelineBuilder.prototype.withRandomTicket = function () {
        this.timeline.ticket = RandomGenerator.randomExtendedTicket();
        return this;
    };
    TimelineBuilder.prototype.withTicket = function (ticket) {
        this.timeline.ticket = ticket;
        return this;
    };
    TimelineBuilder.prototype.withReply = function (reply) {
        var timelineItem = __assign(__assign({ timelineItemType: TimelineItemType.REPLY }, RandomGenerator.reply()), reply);
        this.timeline.timelineItems.push(timelineItem);
        return this;
    };
    TimelineBuilder.prototype.withRandomReplies = function (count) {
        var replies = RandomGenerator.replies(count);
        this.timeline.timelineItems = replies.map(function (r) {
            r.timelineItemType = TimelineItemType.REPLY;
            return r;
        });
        return this;
    };
    TimelineBuilder.prototype.insertRandomReply = function () {
        var reply = RandomGenerator.reply();
        reply.timelineItemType = TimelineItemType.REPLY;
        this.addTimelineItem(reply);
        return this;
    };
    TimelineBuilder.prototype.insertRandomAgentReply = function () {
        var reply = RandomGenerator.reply();
        reply.timelineItemType = TimelineItemType.REPLY;
        reply.type = ReplyType.AGENT;
        this.addTimelineItem(reply);
        return this;
    };
    TimelineBuilder.prototype.insertRandomUserReply = function () {
        var reply = RandomGenerator.reply();
        reply.timelineItemType = TimelineItemType.REPLY;
        reply.type = ReplyType.USER;
        this.addTimelineItem(reply);
        return this;
    };
    TimelineBuilder.prototype.insertRandomReplyWithRecipeId = function () {
        var reply = RandomGenerator.reply();
        reply.timelineItemType = TimelineItemType.REPLY;
        reply.type = ReplyType.AGENT;
        reply.recipeId = RandomGenerator.randomId();
        this.addTimelineItem(reply);
        return this;
    };
    TimelineBuilder.prototype.insertRandomInternalReply = function () {
        var reply = RandomGenerator.reply();
        reply.timelineItemType = TimelineItemType.REPLY;
        reply.type = ReplyType.INTERNAL;
        this.addTimelineItem(reply);
        return this;
    };
    TimelineBuilder.prototype.insertRandomEscalationInternalReply = function () {
        var reply = RandomGenerator.reply();
        reply.timelineItemType = TimelineItemType.REPLY;
        reply.type = ReplyType.INTERNAL;
        reply.escalationReply = true;
        this.addTimelineItem(reply);
        return this;
    };
    TimelineBuilder.prototype.insertRandomInternalReplyWithAttachments = function (name) {
        var reply = RandomGenerator.reply();
        reply.timelineItemType = TimelineItemType.REPLY;
        reply.type = ReplyType.INTERNAL;
        reply.attachments = [{
                name: name,
                status: 200,
                url: "https://e.png"
            }];
        this.addTimelineItem(reply);
        return this;
    };
    TimelineBuilder.prototype.insertInternalReplyWithRecipeId = function () {
        var reply = RandomGenerator.reply();
        reply.timelineItemType = TimelineItemType.REPLY;
        reply.type = ReplyType.INTERNAL;
        reply.recipeId = RandomGenerator.randomId();
        this.addTimelineItem(reply);
        return this;
    };
    TimelineBuilder.prototype.insertEvent = function (event) {
        var item = event;
        item.timelineItemType = TimelineItemType.EVENT;
        this.addTimelineItem(item);
        return this;
    };
    TimelineBuilder.prototype.insertPhoneCallTimeline = function (phoneCallTimeline) {
        var item = phoneCallTimeline;
        item.timelineItemType = TimelineItemType.PHONE_CALL;
        this.addTimelineItem(item);
        return this;
    };
    TimelineBuilder.prototype.build = function () {
        return this.timeline;
    };
    return TimelineBuilder;
}());
export { TimelineBuilder };
//# sourceMappingURL=timeline-builder.js.map